/* eslint-disable import/prefer-default-export, max-lines-per-function, max-params */

export const on = (
  eventName,
  elementSelector,
  handler,
  capture = false,
  documentElement = document
) => {
  const delegatedHandler = function delegatedHandler(e) {
    for (let { target } = e; target && target !== this; target = target.parentNode) {
      if (target.matches(elementSelector)) {
        handler.call(target, e, target);
        break;
      }
    }
  };

  documentElement.addEventListener(eventName, delegatedHandler, capture);

  return () => {
    documentElement.removeEventListener(eventName, delegatedHandler, capture);
  };
};

/* eslint-enable import/prefer-default-export */
